import React from "react";
import { Create } from "react-admin";
import TypeForm from "./TypeForm";

export const TypeCreate = props => {
  const {
    options: { label }
  } = props;
  return (
    <Create title={`สร้าง${label}`} {...props}>
      <TypeForm />
    </Create>
  );
};



// WEBPACK FOOTER //
// ./src/components/type/TypeCreate.js